if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.variantsJson = JSON.parse(document.querySelector('[data-variant]').textContent);
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      findMatchingVariant(selectedOptions) {
        return this.variantsJson.find(variant => {
          return variant.options.every((option, index) => 
            option === selectedOptions[index]
          );
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();    
        
        const offercontainer = document.querySelector('.offer-card__item.offer-card__item--active');    
        const footerbulks = document.querySelectorAll('.footer-card-bulk');    
        if(offercontainer){
          console.log(offercontainer, "offercontainer");
          const activeOffer = offercontainer.querySelector('.offer-card__input:checked');
          const activeOfferValue = activeOffer.value;
          const productinfo  = JSON.parse(document.querySelector('#product-json').innerHTML);
          const productVariants = productinfo.variants;
          console.log(productinfo, "productinfo")
          if(activeOfferValue == -1) {
            console.log("1");
          }else{
              if(footerbulks.length > 0){
                const optionsEles = offercontainer.querySelectorAll('.bulk-options-list');
              const selectedVariants = [];
              
              for(let i = 0; i < optionsEles.length; i++){
                const selectedOptions = [];
                const optionEle = optionsEles[i];                
                const allOptions = optionEle.querySelectorAll('.product-form__input select');
                allOptions.forEach(option => {
                  selectedOptions.push(option.value)                
                });     
                const matchingVariant = this.findMatchingVariant(selectedOptions);
                console.log("matchingVariant", matchingVariant.id);
                selectedVariants.push(matchingVariant.id);
              }
              console.log("selectedVariants", selectedVariants);
              
              let promise = Promise.resolve();
      
              // Process each variant sequentially
              selectedVariants.forEach(variant => {
                  promise = promise.then(() => {
                      return fetch('/cart/add.js', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({
                              id: variant,
                              quantity: 1,
                          }),
                      })
                          .then(response => {
                              if (!response.ok) {
                                  throw new Error(`Failed to add variant ${variant} to cart`);
                              }
                              return response.json();
                          })
                          .then(data => {
                              console.log(`Successfully added variant ${variant} to cart`, data);
                          })
                          .catch(error => {
                              console.error('Error adding variant to cart:', error);
                          });
                  });
              });
          
              // Once all variants are processed
              promise.then(() => {
                  console.log('All variants have been processed.');
              });
             
            return;
              }
              
          }          
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];        

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
